import { defineComponent as _defineComponent } from 'vue'
import { useLogos } from '~/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLogo',
  setup(__props) {

const { logos } = useLogos();

return { __sfc: true,logos }
}

})